<template>
  <div>
    <el-select :value="selected" @input="dispatch" :placeholder="placeholder || $t('message.social')" filterable clearable :multiple="multiple"
      :size="size" class="d-block">
      <el-option v-for="(social,index) in socials" :key="'socials-' + index" :label="social.name" :value="social.id"></el-option>
    </el-select>
  </div>
</template>
<script>
  import {mapGetters, mapActions} from "vuex";
  import { i18n  } from '@/utils/i18n';
  export default {
    props: {
        size: {
            default: 'small'
        },
        placeholder: {
            default: null,
        },
        id:{
            default: null
        },
        multiple:{
            type: Boolean,
            default: false,
        }
    },
     watch:{
      id:{
        handler: function() {
            this.selected = this.id
        },
        immediate: true
      }
    },
    data() {
      return {
        selected: null,
      }
    },
    mounted() {
      if (this.socials && this.socials.length === 0) this.updateInventory()
    },
    computed: {
      ...mapGetters({
        socials: 'social/inventory'
      })
    },
    methods: {
      ...mapActions({
        updateInventory: 'social/inventory'
      }),
      dispatch(e) {
        this.$emit('input', e)       
        this.selected = e
      }
    },
  }

</script>
